import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';
import {LoadTriggers} from '../actions/triggers.actions';

@Injectable()
export class TriggersGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkTriggers()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkTriggers(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectTriggersLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadTriggers());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
